import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.64 5.632c-.902 0-1.64.73-1.64 1.624v8.12C0 16.269.738 17 1.64 17h9.844c.903 0 1.641-.73 1.641-1.624v-8.12c0-.894-.738-1.624-1.64-1.624H1.64Zm3.282 5.684c0 .893.738 1.624 1.64 1.624.903 0 1.641-.731 1.641-1.624 0-.893-.738-1.624-1.64-1.624-.903 0-1.641.73-1.641 1.624Z",
  fill: "#BDBDBD"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5 5.654V3.838C7.5 1.72 9.202 0 11.298 0a3.802 3.802 0 0 1 3.677 2.879.765.765 0 0 1-.547.936.76.76 0 0 1-.927-.552 2.28 2.28 0 0 0-2.203-1.728c-1.253 0-2.279 1.037-2.279 2.303v1.816H7.5Z",
  fill: "#BDBDBD"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };